import { Box } from 'ui/mui';
import { darkModeColors } from 'ui/theme/theme';
import { FooterBottomBarLink } from './FooterBottomBarLink';

export type FooterBottomBarLinkItem = {
  href?: string;
  onClick?: () => void;
  text: string;
  external?: boolean;
  target?: string;
};

type FooterBottomBarProps = {
  maxWidth?: number;
  links: FooterBottomBarLinkItem[];
};

export const FooterBottomBar = ({ maxWidth, links }: FooterBottomBarProps) => {
  return (
    <Box
      sx={{
        width: '100%',
        background: darkModeColors.background.paper,
        py: 2,
        px: 3,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', lg: 'row' },
          gap: { xs: 1, lg: 4 },
          justifyContent: 'center',
          alignItems: { xs: 'flex-start', lg: 'center' },
          mx: 'auto',
          maxWidth,
        }}
      >
        {links.map((link, index) => (
          <FooterBottomBarLink
            key={index}
            href={link.href}
            onClick={link.onClick}
            external={link.external}
            target={link.target}
          >
            {link.text}
          </FooterBottomBarLink>
        ))}
      </Box>
    </Box>
  );
};
